import React from 'react';
import { Container } from 'reactstrap';
import FreightCostView from './FreightCostView';

const IndexFreightCost = () => {
  document.title = 'List Freight Cost';
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <FreightCostView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IndexFreightCost;
